<template>
  <main class="flex flex-col items-stretch | w-full" style="--row-gap: 2rem">
    <header class="flex | bg-white | rounded-2xl | p-8">
      <router-link
        :to="'/' + page.parent"
        class="btn btn--white"
        data-icon="arrow-left"
        aria-labelledby="back-to-project"
      >
        <span id="back-to-project">{{ t('buttons.backToProject') }}</span>
      </router-link>
      <button
        class="btn | ml-auto"
        @click="validate"
        v-if="page.content.isvalidated != 'true'"
        :disabled="
          !page.hasOwnProperty('moodboard') || page.moodboard.length === 0
        "
        :title="
          !page.hasOwnProperty('moodboard') || page.moodboard.length === 0
            ? t('buttons.validateMinimum')
            : undefined
        "
      >
        {{ t('buttons.validate') }}
      </button>
    </header>
    <Images />
  </main>
</template>
<script setup>
import Images from '../components/project/brief/Images.vue';
import { usePageStore } from '../stores/page';
import { storeToRefs } from 'pinia';
import { useApiStore } from '../stores/api';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { page } = storeToRefs(usePageStore());
const api = useApiStore();

function validate() {
  api.validateBrief(page.value.uri).then((res) => {
    location.href = '/' + page.value.parent;
  });
}
</script>

<style scoped>
@media (max-width: 540px) {
  #back-to-project {
    display: none;
  }
}
</style>
